<template>
    <li v-if="data.children && data.children.length == 0" class="nav-item">
        <!-- <a :href="data.link" :target="data.target" class="nav-link">{{data.translate.name}}</a> -->
        <router-link
            v-if="data.link && !data.link.match(/^#/i) && !data.link.match(/^http/i)"
            :to="{name: data.link, params: data.link_param ? Object.assign({lang: def_lang}, data.link_param) : {lang: def_lang} }"
            :target="data.target"
            class="nav-link px-3 text-site"
            v-html="data.translate.name"
        >
    </router-link>
    <!-- {{data.translate.name}} -->
        <a v-else="" :href="data.link"
            :target="data.target"
            class="nav-link px-3 text-site"
            v-html="data.translate.name"
        >
    </a>
    <!-- {{data.translate.name}} -->
    </li>
    <li v-if="data.children && data.children.length > 0" class="nav-item dropdown">
            <!-- :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light1`" -->
        <!-- <a
            class="nav-link dropdown-toggle1"
            :href="data.link"
            :target="data.target"
            data-bs-toggle="dropdown"
            aria-expanded="false"
        >
            {{ data.translate.name }}
        </a> -->
        <router-link
            v-if="data.link && !data.link.match(/^#/i) && !data.link.match(/^http/i)"
            :to="{name: data.link, params: data.link_param ? Object.assign({lang: def_lang}, data.link_param) : {lang: def_lang} }"

            class="nav-link dropdown-toggle1 px-3 text-site"
            :target="data.target"
            aria-expanded="false"
            v-html="data.translate.name"
            >
        </router-link>
        <template v-else>
             <a
                :href="data.link"
                class="nav-link dropdown-toggle1 px-3 text-site"
                :target="data.target"
                aria-expanded="false"
                v-html="data.translate.name"
                data-bs-toggle="dropdown"
            >
            </a>
        </template>
        <ul class="dropdown-menu" v-if="data.children && data.children.length">
            <MenuItem v-for="child in data.children"
                :key="child.id"
                :data="child" />
        </ul>
    </li>
</template>

<script>
import { useRoute } from "vue-router";

import MenuItem from './MenuItem';

export default {
    name: "MenuItemC",
    components:{
        MenuItem,
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    setup() {
        const route = useRoute();

        const def_lang = route.params && route.params.lang !== undefined ? route.params.lang : "az";

        return {def_lang};
    },
}
</script>

<style scoped>
.dropdown a{
    word-break: break-all !important;
}
.dropdown:hover > a{
    background-color: #cdc8c8;
}
@media(min-width: 576px){
    .nav-link:hover, .dropdown:hover>a{
        background-color: #cdc8c8;
    }
    .dropdown-menu{
        margin-top: 0px;
    }
    .dropdown-menu>.dropdown:hover>a{
        background-color: #cdc8c8;
    }
    .dropdown>.dropdown-menu{
        display: none;
        padding: 5px;
        border-radius: 0px;
        width: 280px;
    }

    .dropdown:hover>.dropdown-menu{
        display: block;
    }
    .navbar-nav>.dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        margin-left: 5px;
    }
    .dropdown-menu>.dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        position: absolute;
        top: 20%;
        right: 10px;
        left: auto;
    }
    .dropdown-menu>.dropdown:hover>a::after{
        transform: rotate(-90deg);
    }

    .dropdown-menu>.dropdown:hover>.dropdown-menu{
        display: block;
        top: -5px;
        margin-left: 270px;
    }

    /* .dropdown-menu > .dropdown:hover > a {
        border-radius: 5px;
    }
    .dropdown > .dropdown-menu {
        border-radius: 5px;
    }
    .nav-link:hover, .dropdown:hover > a {
        border-radius: 5px;
    } */
}
@media(max-width: 576px){
    .dropdown>.dropdown-menu{
        padding: 5px;
    }
    .dropdown>.dropdown-menu.show{
        display: block;
    }
    .dropdown-menu.show .dropdown-menu{
        display: block;
        margin-left: 25px;
    }
    .navbar-nav>.dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        margin-left: 5px;
    }
    .dropdown-menu.show .dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        position: absolute;
        /* top: 20%; */
        right: 10px;
        left: auto;
    }
}
</style>
